import React, { useEffect, useRef } from "react";
import "./Impact.css";

const Impact = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const actionsRef = useRef(null);
  const borderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (titleRef.current) titleRef.current.classList.add("impact__title--animate");
            if (descriptionRef.current)
              descriptionRef.current.classList.add("impact__description--animate");
            if (actionsRef.current) actionsRef.current.classList.add("impact__actions--animate");
            if (borderRef.current) borderRef.current.classList.add("impact__border--animate");
          }
        });
      },
      { threshold: 0.2 }
    );

    const currentSection = sectionRef.current;
    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  return (
    <section className="impact" id="impact" aria-label="Our Impact" ref={sectionRef}>
      <div className="impact__container">
        <div className="impact__content">
          <h2 className="impact__title" ref={titleRef}>
            Looking to Strengthen Families and Create Lasting Community Impact?
          </h2>

          <p className="impact__description" ref={descriptionRef}>
            We work alongside organizations to design effective fatherhood programs, strengthen family
            engagement, and build sustainable services that support thriving communities.
          </p>

          <div className="impact__actions" ref={actionsRef}>
            <a href="/contact" className="impact__button impact__button--primary">
              Start the Conversation
            </a>
            <a href="/services" className="impact__button impact__button--secondary">
              Our Services
            </a>
          </div>
        </div>
      </div>

      <div className="impact__border" aria-hidden="true" ref={borderRef}></div>
    </section>
  );
};

export default Impact;